import { Button, ButtonProps } from '@material-ui/core';

export interface SubmitButtonProps extends ButtonProps {
    label?: string;
    id?: string;
    loading?: boolean;
    labelWhileLoading?: string;
}

export function SubmitButton({ label, ...rest }: SubmitButtonProps) {
    return (
        <Button fullWidth {...rest} className="customBtn">
            {label}
        </Button>
    );
}

export function CancelButton({ label, ...rest }: SubmitButtonProps) {
    return (
        <Button fullWidth {...rest} className="customBtn">
            {label}
        </Button>
    );
}

export const LoadDots = ({ labelWhileLoading = '' }: any) => {
    return (
        <label>
            {' '}
            {labelWhileLoading}
            <span className="sending-dots" data-testid="loading-dots">
                <i></i>
                <i></i>
                <i></i>
            </span>
        </label>
    );
};

export const SubmitButtonWithLoader = ({
    loading,
    label,
    labelWhileLoading,
    ...rest
}: SubmitButtonProps) => {
    return loading ? (
        <Button {...rest} className="customBtn" disabled>
            {labelWhileLoading}
            {<LoadDots />}
        </Button>
    ) : (
        <Button
            {...rest}
            // onClick={handleSubmit}
            className="customBtn"
        >
            {label}
        </Button>
    );
};
